import { INCREMENT_REQUESTED, INCREMENT, DECREMENT_REQUESTED, DECREMENT } from './CounterConstants'
import update from 'immutability-helper'
import {createReducer} from "utils/ReduxUtils";

const initialState = {
  count: 0,
  isIncrementing: false,
  isDecrementing: false
}


let CounterHandlers = { 
  [INCREMENT_REQUESTED]: (state, action) => {
    return update(state, {
      isIncrementing: { $set: true }
    })
  }, 
  [INCREMENT]: (state, action) => {
    return update(state, {
      count: { $set: state.count + 1 },
      isIncrementing: { $set: false }
    })    
  }, 
  [DECREMENT_REQUESTED]: (state, action) => {
    return update(state, {
      isDecrementing: { $set: true }
    })
  },
  [DECREMENT]: (state, action) => {
   return update(state, {
      count: { $set: state.count - 1 },
      isDecrementing: { $set: false }
    })    
  }
} 

export default createReducer(initialState, CounterHandlers)


// WEBPACK FOOTER //
// ./src/redux-modules/counter/CounterReducer.js